export default "assets/images/404-bg-327f9cba.png";